import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="container py-4" style={{ maxWidth: "800px", margin: "auto", textAlign: "left" }}>
            <h2><strong>BachatGat Mitra बचत गट मित्र</strong> — Privacy Policy</h2>
            <h6 style={{ fontSize: "small" }}>Last updated on 21-11-2025 22:00:00 IST</h6>

            <p style={{ fontSize: "small" }}>
                <strong>BachatGat Mitra बचत गट मित्र</strong> App is a product of <strong>Vakralabs Services</strong>, located at Punawale,
                Pimpri-Chinchwad, Pune, Maharashtra – 411033.
            </p>
            <p style={{ fontSize: "small" }}>
                Please read this Privacy Policy carefully before using the <strong>BachatGat Mitra बचत गट मित्र</strong> App. By using this app,
                you agree to all the terms mentioned below.
            </p>

            <ol style={{ fontSize: "small", paddingLeft: "20px" }}>
                <li>
                    <strong>Information Collection</strong>
                    <ul>
                        <li>
                            <strong>User Information:</strong> Name, mobile number, and email address for account
                            creation.
                        </li>
                        <li>
                            <strong>SHG Group Data:</strong> Details related to Self Help Groups (SHG), members,
                            and financial records entered by users.
                        </li>
                        <li>
                            <strong>Device Information:</strong> We may access limited device information (such as
                            device ID) only for <strong>app security and fraud prevention.</strong>
                            <ul>
                                <li>
                                    Device information is also used for app performance, security, analytics, and advertising (via Google AdMob).
                                </li>
                                <li>
                                    <strong>We do not collect call logs, SIM details, or phone numbers.</strong>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>

                <li>
                    <strong>Advertising & AdMob</strong>
                    <ul>
                        <li>
                            <strong>BachatGat Mitra बचत गट मित्र</strong> uses <strong>Google AdMob</strong> as a third-party advertising partner.
                        </li>
                        <li>
                            The app uses Google Mobile Ads SDK, which may collect certain information for advertising and analytics.

                        </li>
                        <li>
                            Google may collect and use personal and non-personal data such as:
                            <ul>
                                <li>Google Advertising ID, IP address, Usage data,Diagnostics, Approximate (non-precise) location</li>
                            </ul>
                        </li>
                        <li>
                            <strong>This data is used to:</strong>
                            <ul>
                                <li>Serve ads, Analyze ad performance, Prevent fraud, Provide personalized or non-personalized ads</li>
                            </ul>
                        </li>
                        <li>
                            You can opt out of personalized ads from Google by adjusting your device settings or visiting{" "}
                            <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
                                Google Ad Settings
                            </a>.
                        </li>
                        <li>
                            To learn how Google uses your data, visit the Google Partner Policy:{" "}
                            <a href=" https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">
                                https://policies.google.com/technologies/partner-sites
                            </a>
                        </li>
                    </ul>
                </li>

                <li><strong>Firebase Push Notifications</strong>
                    <ul>
                        <li>We use Firebase Cloud Messaging (FCM) to send push notifications.</li>

                        <li>
                            FCM collects:
                            <ul>
                                <li>Device Token / Device Identifier, App usage data, Crash reports</li>
                            </ul>
                        </li>
                        <li>We do not use FCM for advertising or marketing without consent.</li>
                        <li>Notifications can be turned off at any time through device settings.</li>
                    </ul>

                </li>
                <li>
                    <strong>Information Usage</strong>
                    <ul>
                        <li>To verify user identity and secure login.</li>
                        <li>To enable saving group management, transaction tracking, and reporting.</li>
                        <li>To improve user experience and app performance.</li>
                        <li>Sending important alerts and notifications <strong>(via Firebase)</strong></li>
                        <li>To show relevant <strong>ads (via Google AdMob)</strong></li>
                    </ul>
                </li>

                <li>
                    <strong>Data Sharing</strong>
                    <ul>
                        <li>
                            <strong>BachatGat Mitra बचत गट मित्र</strong> <strong>does not sell, rent, or trade</strong> your personal data.
                        </li>
                        <li>
                            Data may be shared with:
                            <ul>
                                <li>Google AdMob (for advertisement delivery)</li>
                                <li>Government authorities if legally required</li>
                            </ul>
                        </li>
                        <li>No sensitive personal data is shared.</li>
                    </ul>
                </li>

                <li>
                    <strong>Data Security</strong>
                    <ul>
                        <li>We use encryption and secure storage to protect your information.</li>
                        <li>All communication between the app and server uses <strong>HTTPS</strong>.</li>
                    </ul>
                </li>

                <li>
                    <strong>User Control</strong>
                    <ul>
                        <li>You can edit or delete your data anytime within the app or by contacting support.</li>
                        <li>You can opt out of personalized ads at any time.</li>
                        <li><strong>Data Deletion Request</strong>

                            <ul>
                                <li>Users may request deletion of their personal information and SHG data at any time.</li>
                                <li>To request deletion, users can contact us at support@vakralabs.com.</li>
                                <li>After receiving your request:

                                    <ol>
                                        <li>We verify your identity for security.</li>
                                        <li>All personal data, SHG data, and account information will be permanently deleted from our servers.</li>
                                        <li>Deletion will be completed within 7–30 days.</li>
                                        <li>We will confirm via email once the deletion is complete.</li>
                                        <li>Backup copies may take up to 30 days to be fully removed.</li>
                                    </ol>
                                </li>
                            </ul></li>

                    </ul>
                </li>
                <li>
                    <strong>Children's Privacy</strong>
                    <ul>
                        <li> <strong>BachatGat Mitra बचत गट मित्र</strong> app is NOT directed to children under the age of 13.</li>
                        <li>We do not knowingly collect personal information from children under 13.</li>
                    </ul>
                </li>

                <li>
                    <strong>Changes to this Policy</strong>
                    <ul>
                        <li>
                            We may update this Policy from time to time. When updated, the new version will be posted on our website and inside the app.
                        </li>
                    </ul>
                </li>

                <li>
                    <strong>Contact Us</strong>
                    <address style={{ fontSize: "small", lineHeight: "1.4em" }}>
                        <strong>Vakralabs Services</strong><br />
                        C-902, Bhalchandra Akashvan <br />
                        Punawale, Pimpri-Chinchwad, Pune – 411033 <br />
                        📞 +91 9423 886 986 <br />
                        📧 <a href="mailto:support@vakralabs.com">support@vakralabs.com</a>
                    </address>
                </li>
            </ol>
        </div>
    );
};

export default PrivacyPolicy;
